/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Timezone,
    TimezoneFromJSON,
    TimezoneFromJSONTyped,
    TimezoneToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeEndpointResponse
 */
export interface TimeEndpointResponse {
    /**
     * 
     * @type {number}
     * @memberof TimeEndpointResponse
     */
    time: number;
    /**
     * 
     * @type {Timezone}
     * @memberof TimeEndpointResponse
     */
    timezone: Timezone;
    /**
     * 
     * @type {Array<Timezone>}
     * @memberof TimeEndpointResponse
     */
    timezones: Array<Timezone>;
}

export function TimeEndpointResponseFromJSON(json: any): TimeEndpointResponse {
    return TimeEndpointResponseFromJSONTyped(json, false);
}

export function TimeEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': json['time'],
        'timezone': TimezoneFromJSON(json['timezone']),
        'timezones': ((json['timezones'] as Array<any>).map(TimezoneFromJSON)),
    };
}

export function TimeEndpointResponseToJSON(value?: TimeEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'timezone': TimezoneToJSON(value.timezone),
        'timezones': ((value.timezones as Array<any>).map(TimezoneToJSON)),
    };
}


